import { ref, computed, watch } from 'vue'
import createGetProgressionApi from './partials/get';
import createSubmitProgressionApi from './partials/submit';
import createDeleteProgressionAPi from './partials/delete';

export function createProgression(){
    const details = ref({
        key   : '',
        email : '',
    })

    const get               = createGetProgressionApi(details)
    const submit            = createSubmitProgressionApi(details)
    const deleteProgression = createDeleteProgressionAPi(details)

    watch(
        details, 
        (updatedDetails) => {
            get.api.parameters.value.key   = updatedDetails.key
            get.api.parameters.value.email = updatedDetails.email

            submit.api.parameters.value.key   = updatedDetails.key
            submit.api.parameters.value.email = updatedDetails.email

            deleteProgression.api.parameters.value.key = updatedDetails.key
        },
        { deep: true, immediate: true }
    )
    
    return {
        /**
         * If we're current running a loader
         */
        loading: computed(() => {
            return get.loading.value
                || submit.loading.value 
                || deleteProgression.loading.value
        }),

        details: details,

        actions: {
            get: get,

            submit: submit,

            delete: deleteProgression,
        }
    }
}